import React, { Fragment } from "react";
import { Form, Col, Row, Modal, Button } from "react-bootstrap";

import html2canvas from "html2canvas";
import jsPDF from "jspdf";

import { FieldGroup } from "../bootstrap/Forms.FieldGroup";
import { ENDPOINTS } from "../../constants/endpoints";
import PaymentModal from "./PaymentModal";
import RPPaymentModal from "./RPPaymentModal";
import { formatCurrency } from "../../adukku_utils/formatCurrency";
import { BlockedReason } from "@google/genai";

//export default class FileManager extends React.Component {
class FileManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      no_of_imgcredits: 0,
      tmp_no_of_imgcredits: 10,
      overlay: props.overlay || { visible: false },
      is_preset_display: false,
      categories: props.categories,
      role: null,
      isFileManagerOpen: false,
      folders: [],
      user_products: {},
      folderHierarchy: {},
      basePath: "",
      show: false,
      currentFile: {},
      uploadedImages: { none: [] },
      uploadedImageNames: { none: [] },
      purchaseHistory: [],
      convenienceCharges: 0.05,
      host_url: null,
      uid: null,
      expiries: {},
      storage_unit: "GIGA_BYTE",
      currentOrder: null,
      isEditProductClicked: false,
      subscription_id: "",
      subscription_status: "",
      sub_start_date: null,
      sub_end_date: null,
      imgCredits: 0
    };
  }

  componentDidMount() {
    // if (this.state.isFileManagerOpen) this.getPurchaseHistory();
    // this.getPurchaseHistory();
    // this.getsubidfromDB();
    this.getimgcreditsfromDB();
  }

  getsubidfromDB = () => {
    let subid_uri = ENDPOINTS.subid.index.uri;
    let noRecords;

    (async () => {
      noRecords = await fetch(subid_uri, {
        method: "GET",
        headers: { "content-type": "application/json" }
      })
        .then((response) => response.json())
        .then((data) => {
          this.setState({
            subscription_id: parseInt(data.sub_id.split("-")[1]),
            subscription_status: data.sub_status,
            sub_start_date: data.sub_start_date,
            sub_end_date: data.sub_end_date
          });
        });
    })();
  };

  getimgcreditsfromDB = () => {
    let imgcredits_uri = ENDPOINTS.imgcredits.index.uri;
    let noRecords;

    (async () => {
      noRecords = await fetch(imgcredits_uri, {
        method: "GET",
        headers: { "content-type": "application/json" }
      })
        .then((response) => response.json())
        .then((data) => {
          this.setState({ imgCredits: data.imgcredits });
        });
    })();
  };

  getPurchaseHistory = () => {
    let uri = ENDPOINTS.user_imgcredits.list.uri;
    let that = this;
    return fetch(uri, {
      method: "GET",
      headers: { "content-type": "application/json" }
    })
      .then((response) => response.json())
      .then((response) => {
        that.setState({
          purchaseHistory: response.user_imgcredits,
          convenienceCharges: parseFloat(
            response.convience_charges.transaction_fee || 0.05
          ),
          host_url: response.host_url,
          uid: response.uid
        });
      });
  };

  openFileManager = () => {
    this.setState({ isFileManagerOpen: !this.state.isFileManagerOpen });
    this.getPurchaseHistory();
    this.getsubidfromDB();
  };

  getOrderInvoice = (order) => {
    let user = {};

    return (
      <Modal
        dialogClassName="modal-90w"
        centered="true"
        show={this.state.isEditProductClicked}
        onHide={(e) => {
          this.setState({ currentOrder: null, isEditProductClicked: false });
        }}
      >
        <Form className="override_form">
          <Modal.Header closeButton>
            <Modal.Title>Invoice</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div id="divToPrint" style={{ justifyContent: "center" }}>
              <div
                id="divToPrint2"
                // className="mt4"
                style={{
                  backgroundColor: "#fff",
                  width: "60%",
                  padding: "50px",
                  minHeight: "297mm",
                  marginLeft: "auto",
                  marginRight: "auto",
                  border: "1px solid",
                  boxShadow: `0 10px 25px rgba(0, 0, 0, 0.5)`
                }}
              >
                <table style={{ width: "100%" }}>
                  <tr>
                    <td>
                      <img
                        src={`${this.state.host_url}/Composz-logo-black-trans.png`}
                        style={{ height: "70px" }}
                      />
                    </td>
                    <td style={{ textAlign: "right" }}>
                      <span
                        style={{
                          fontSize: "34px",
                          color: "#0070c0",
                          fontWeight: "34px"
                        }}
                      >
                        <b>INVOICE</b>
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>COMPOSZ LLC,</td>{" "}
                    <td style={{ textAlign: "right" }}>
                      Invoice #: INVENH00000{order.id}
                    </td>
                  </tr>
                  <tr>
                    <td>#121 HAUT BRION AVENUE</td>{" "}
                    <td style={{ textAlign: "right" }}>
                      Invoice Date: {order.updated_at}
                    </td>
                  </tr>
                  <tr>
                    <td>NEWARK, DE-19702.</td>{" "}
                    <td style={{ textAlign: "right" }}>
                      Invoice Amount:
                      {formatCurrency(order.total_amount * 100, 100, "USD")}
                      {/* {(order.total_amount / 100).toFixed(2)} */}
                    </td>
                  </tr>
                  <tr>
                    <td></td>{" "}
                    <td style={{ textAlign: "right" }}>
                      Status:{" "}
                      <span style={{ color: "#92d050", fontSize: "20px" }}>
                        PAID
                      </span>
                    </td>
                  </tr>
                </table>
                <span>
                  <b>BILLED TO</b>
                </span>
                <p>
                  <span>{order.full_name}</span>
                  <br />
                  <span>{order.email}</span>
                  <br />
                  <span>{order.pg_user_email}</span>
                  <br />
                  <span>{order.address}</span>
                  <br />
                  {/* <span>Bangalore, 560076.</span> */}
                </p>
                <br />
                <table style={{ width: "100%" }}>
                  <thead>
                    <tr
                      style={{
                        borderBottom: "0.5px solid black",
                        borderTop: "0.5px solid black"
                      }}
                    >
                      <th>Description</th>
                      <th>Price</th>
                      <th>Quantity</th>
                      <th>Amount</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td>Image Credits</td>
                      <td>${"1.00"}</td>
                      <td>{order.no_of_imgcredits}</td>
                      <td>
                        {formatCurrency(
                          // order.total_amount * 100 - order.pg_transaction_fee, 100,"USD"
                          order.no_of_imgcredits * 100,
                          100,
                          "USD"
                        )}
                        {/* ${storageAmount.toFixed(2)} */}
                      </td>
                      <tr>
                        <td>Bonus Image Credits</td>
                        <td>${"0.00"}</td>
                        <td>{Math.trunc(order.no_of_imgcredits / 10)}</td>
                        <td>${"0.00"}</td>
                      </tr>
                    </tr>
                  </tbody>
                </table>
                <table style={{ width: "100%" }}>
                  <thead>
                    <tr>
                      <th>PAYMENT DETAILS</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Paypal Transaction ID: {order.paypal_capture_id}</td>
                      <td style={{ textAlign: "right" }}>
                        Item (s) Subtotal:{" "}
                        {formatCurrency(
                          //order.total_amount * 100 - order.pg_transaction_fee, 100, "USD"
                          order.no_of_imgcredits * 100,
                          100,
                          "USD"
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td style={{ textAlign: "right" }}>
                        Convenience charges:{" "}
                        {formatCurrency(
                          order.pg_fixed_fee * order.no_of_imgcredits,
                          100,
                          "USD"
                        )}
                        {/* {formatCurrency(order.pg_transaction_fee, 100, "USD")} */}
                        {/* {(order.pg_transaction_fee / 100).toFixed(2)} */}
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td style={{ textAlign: "right" }}>
                        Tax to be collected: {formatCurrency(0, 100, "USD")}
                        {/* {formatCurrency(order.pg_fixed_fee, 100, "USD")} */}
                        {/* ${(order.pg_fixed_fee / 100).toFixed(2)} */}
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td style={{ textAlign: "right" }}>
                        <b>
                          GRAND TOTAL:{" "}
                          {formatCurrency(order.total_amount * 100, 100, "USD")}
                          {/* {(order.total_amount / 100).toFixed(2)} */}
                        </b>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <p>Thanks for your purchase</p>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              type="button"
              onClick={() => {
                this.printDocument(`INVENH00000${order.id}`);
              }}
            >
              Download
            </Button>
            <Button
              onClick={(e) => {
                this.setState({ isEditProductClicked: false });
              }}
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    );
  };

  getrazorpayOrderInvoice = (order) => {
    let user = {};
    let convience_charges = 0.05;

    return (
      <Modal
        dialogClassName="modal-90w"
        centered="true"
        show={this.state.isEditProductClicked}
        onHide={(e) => {
          this.setState({ currentOrder: null, isEditProductClicked: false });
        }}
      >
        <Form className="override_form">
          <Modal.Header closeButton>
            <Modal.Title>Invoice</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div id="divToPrint" style={{ justifyContent: "center" }}>
              <div
                id="divToPrint2"
                // className="mt4"
                style={{
                  backgroundColor: "#fff",
                  width: "60%",
                  padding: "50px",
                  minHeight: "297mm",
                  marginLeft: "auto",
                  marginRight: "auto",
                  border: "1px solid",
                  boxShadow: `0 10px 25px rgba(0, 0, 0, 0.5)`
                }}
              >
                <table style={{ width: "100%" }}>
                  <tr>
                    <td>
                      <img
                        src={`${this.state.host_url}/Composz-logo-black-trans.png`}
                        style={{ height: "70px" }}
                      />
                    </td>
                    <td style={{ textAlign: "right" }}>
                      <span
                        style={{
                          fontSize: "34px",
                          color: "#0070c0",
                          fontWeight: "34px"
                        }}
                      >
                        <b>INVOICE</b>
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>LIFE COLORS,</td>{" "}
                    <td style={{ textAlign: "right" }}>
                      Invoice #: INVENH00000{order.id}
                    </td>
                  </tr>
                  <tr>
                    <td>#9, 4th Cross, Kothanur Main Road,</td>{" "}
                    <td style={{ textAlign: "right" }}>
                      Invoice Date: {order.updated_at}
                    </td>
                  </tr>
                  <tr>
                    <td>Bangalore 560 062.</td>{" "}
                    <td style={{ textAlign: "right" }}>
                      Invoice Amount:{" "}
                      {formatCurrency(order.total_amount, 1, "INR")}
                      {/* {(order.total_amount / 100).toFixed(2)} */}
                    </td>
                  </tr>
                  <tr>
                    <td>GSTIN: 29AUTPB5544P1ZS; GST SAC Code: 998434</td>{" "}
                    <td style={{ textAlign: "right" }}>
                      Status:{" "}
                      <span style={{ color: "#92d050", fontSize: "20px" }}>
                        PAID
                      </span>
                    </td>
                  </tr>
                </table>
                <span>
                  <b>BILLED TO</b>
                </span>
                <p>
                  <br></br>
                  <span>{order.user_name}</span>
                  <br></br>
                  <span>{order.razorpay_capture.email}</span>
                  <br></br>
                  <span>{order.razorpay_capture.contact}</span>
                  <br />
                </p>
                <br />
                <table style={{ width: "100%" }}>
                  <thead>
                    <tr
                      style={{
                        borderBottom: "0.5px solid black",
                        borderTop: "0.5px solid black"
                      }}
                    >
                      <th>Description</th>
                      <th>Price</th>
                      <th>Quantity</th>
                      <th>Amount</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td>Image Credits</td>
                      <td>₹{"35.00"}</td>
                      <td>{order.no_of_imgcredits}</td>
                      <td>
                        {formatCurrency(
                          order.no_of_imgcredits * 35.0,
                          1,
                          "INR"
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>Bonus Image Credits</td>
                      <td>₹{"0.00"}</td>
                      <td>{Math.trunc(order.no_of_imgcredits / 10)}</td>
                      <td>₹{"0.00"}</td>
                    </tr>
                  </tbody>
                </table>
                <table style={{ width: "100%" }}>
                  <thead>
                    <tr>
                      <th>PAYMENT DETAILS</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Razorpay Payment ID: {order.razorpay_capture.id}</td>
                      <td style={{ textAlign: "right" }}>
                        Item (s) Subtotal:{" "}
                        {formatCurrency(
                          order.no_of_imgcredits * 35.0,
                          1,
                          "INR"
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Payment Mode: {order.razorpay_capture.method}
                        {order.razorpay_capture.method == "netbanking"
                          ? "-" + order.razorpay_capture.bank
                          : ""}
                        {order.razorpay_capture.method == "card"
                          ? "-" +
                            order.razorpay_capture.card.network +
                            "-xxxx-" +
                            order.razorpay_capture.card.last4
                          : ""}
                        {order.razorpay_capture.method == "upi"
                          ? "-" +
                            order.razorpay_capture.vpa +
                            "-Ph:" +
                            order.razorpay_capture.acquirer_data.rrn
                          : ""}
                        {order.razorpay_capture.method == "wallet"
                          ? "-" + order.razorpay_capture.wallet
                          : ""}
                      </td>
                      <td style={{ textAlign: "right" }}>
                        Convenience charges:{" "}
                        {formatCurrency(
                          order.no_of_imgcredits *
                            35.0 *
                            (order.pg_fixed_fee / 100),
                          1,
                          "INR"
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Transaction ID:
                        {order.razorpay_capture.method == "netbanking"
                          ? order.razorpay_capture.acquirer_data
                              .bank_transaction_id
                          : ""}
                        {order.razorpay_capture.method == "card"
                          ? order.razorpay_capture.acquirer_data.auth_code
                          : ""}
                        {order.razorpay_capture.method == "upi"
                          ? order.razorpay_capture.acquirer_data
                              .upi_transaction_id
                          : ""}
                        {order.razorpay_capture.method == "wallet"
                          ? " N/A"
                          : ""}
                      </td>
                      <td style={{ textAlign: "right" }}>
                        GST 18%:{" "}
                        {formatCurrency(
                          (order.no_of_imgcredits * 35.0 +
                            order.no_of_imgcredits *
                              35.0 *
                              (order.pg_fixed_fee / 100)) *
                            0.18,
                          1,
                          "INR"
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td style={{ textAlign: "right" }}>
                        <b>
                          GRAND TOTAL :{" "}
                          {formatCurrency(order.total_amount, 1, "INR")}
                          {/* {(order.total_amount / 100).toFixed(2)} */}
                        </b>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <p> Thanks for your purchase</p>
                <p> --team Composz</p>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              type="button"
              onClick={() => {
                this.printDocument(`INVENH00000${order.id}`);
              }}
            >
              Download
            </Button>
            <Button
              onClick={(e) => {
                this.setState({ isEditProductClicked: false });
              }}
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    );
  };

  printDocument = (orderId) => {
    const input = document.getElementById("divToPrint2");
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("image/jpeg");
      const pdf = new jsPDF();
      var width = pdf.internal.pageSize.getWidth();
      var height = pdf.internal.pageSize.getHeight();

      pdf.addImage(imgData, "JPEG", 0, 0, width, height);
      // pdf.output('dataurlnewwindow');
      pdf.save(`${orderId}.pdf`);
    });
  };

  getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  countryCode = this.getCookie("countryCode");

  render() {
    const {
      isFileManagerOpen,
      purchaseHistory,
      user_products,
      basePath,
      current_path,
      prev_path,
      expiries,
      currentOrder
    } = this.state;

    return (
      <li>
        <a onClick={this.openFileManager}>{"Buy Image Credits"}</a>

        {this.countryCode !== "IN" ? (
          <PaymentModal
            fields={this.state}
            resetImgcredit={() => {
              this.setState({ no_of_imgcredits: 0 });
            }}
          />
        ) : (
          <RPPaymentModal
            fields={this.state}
            resetImgcredit={() => {
              this.setState({ no_of_imgcredits: 0 });
            }}
          />
        )}

        <Modal
          dialogClassName="modal-90w"
          centered="true"
          show={isFileManagerOpen}
          onHide={this.openFileManager}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginRight: "50px"
                }}
              >
                <h4 style={{ alignContent: "left" }}>Purchase Image Credits</h4>
                <h4 style={{ alignContent: "right" }}>
                  Available Image Credits:{" "}
                  <span
                    style={{
                      color: this.state.imgCredits > 0 ? "green" : "red"
                    }}
                  >
                    {this.state.imgCredits}
                  </span>
                </h4>
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="flex_align">
              <FieldGroup
                id="formControlPages"
                type="number"
                label="Number of Image Credits"
                name="no_of_imgcredits"
                min="1"
                placeholder="Number of Image Credits"
                required="required"
                onChange={({ target: { name, value } }) => {
                  // this.setState({ [name]: parseInt(value) });
                  this.setState({ tmp_no_of_imgcredits: parseInt(value) });
                }}
                onBlur={({ target: { name, value } }) => {
                  if (value < 1) {
                    alert("Minimum Number of Image Credits is 1");
                    this.setState({ tmp_no_of_imgcredits: 1 });
                  }
                }}
                value={this.state.tmp_no_of_imgcredits}
              />

              <Button
                style={{
                  backgroundColor: "green",
                  color: "white",
                  fontSize: "20px",
                  marginLeft: "15px",
                  marginTop: "15px"
                }}
                onClick={() => {
                  if (this.state.tmp_no_of_imgcredits < 1) {
                    alert(
                      "Minimum Number of Image Credits value should be greater 1 or more. Please enter valid value"
                    );
                    this.setState({ tmp_no_of_imgcredits: 1 });
                    return false;
                  } else {
                    this.setState({
                      no_of_imgcredits: this.state.tmp_no_of_imgcredits
                    });
                  }
                }}
              >
                Proceed to Payment
              </Button>

              <br></br>

              <div
                style={{
                  display: "flex",
                  flexFlow: "column",
                  marginLeft: "60px",
                  marginTop: "20px",
                  padding: "20px",
                  backgroundColor: "#ffcf00",
                  boxShadow:
                    "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
                }}
              >
                <strong style={{}}>
                  Price for 1 Image Credit:{" "}
                  {this.countryCode !== "IN" ? "$1.00" : " ₹35.00"} +
                  Convenience charges + Applicable Tax
                </strong>
                <br></br>
                <strong style={{ marginTop: "-15px" }}>
                  Minimum Image Credits to be purchased is 1.
                </strong>
                <strong style={{ marginTop: "10px" }}>
                  1 Bonus Image credit for every 10 Image credits purchased.
                </strong>
              </div>
            </div>

            {purchaseHistory && purchaseHistory.length > 0 && (
              <Row>
                <Col md={12}>
                  <table className="table table-bordered">
                    <caption className="storage_history">
                      Purchase Image Credits - History
                    </caption>
                    <thead>
                      <tr>
                        <th scope="col">No of Image Credits</th>
                        <th scope="col">Purchased On</th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {purchaseHistory &&
                        purchaseHistory.map((imgcredit) => {
                          return (
                            <tr key={imgcredit.id}>
                              <td>{imgcredit.no_of_imgcredits}</td>
                              <td>{`${new Date(
                                imgcredit.purchased_on
                              ).toLocaleString()}`}</td>

                              <td>
                                <Button
                                  className="btnsmall btn-success"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    this.setState({
                                      currentOrder: imgcredit,
                                      isEditProductClicked:
                                        !this.state.isEditProductClicked
                                    });
                                  }}
                                >
                                  Download Invoice
                                </Button>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </Col>
              </Row>
            )}
          </Modal.Body>
        </Modal>
        {this.state.isEditProductClicked &&
          (this.countryCode !== "IN"
            ? this.getOrderInvoice(this.state.currentOrder)
            : this.getrazorpayOrderInvoice(this.state.currentOrder))}
      </li>
    );
  }
}

export default FileManager;
